import * as PIXI from "pixi.js";
import { SwitcherButtonStyle } from "../../../types/Interface";
import { SwitcherBgColors } from "../../../types/Enum";
import addInteractivity from "../../../utils/addInteractivity";
import SwitcherButtonRenderer from "./SwitcherButtonRenderer";
import { disabledfilter } from "../../../filters";
import { CustomCursorType } from "../CustomCursor/CustomCursor";


type IconType = PIXI.Sprite | PIXI.Text | PIXI.Graphics;


export default class SwitcherButton extends PIXI.Container {
  private ButtonRenderer = new SwitcherButtonRenderer();
  public icon: PIXI.Sprite | PIXI.Text | PIXI.Graphics;
  private onHandleFunc: () => void;
  private onHandleSecondFunc: () => void;
  private updateBg: boolean = true;
  private buttonBg = new PIXI.Graphics();
  private isOn: boolean = false;

  constructor(
    private buttonStyle: SwitcherButtonStyle,
    icon: IconType,
    updateBg: boolean = true,
    onHandleFunc: () => void,
    onHandleSecondFunc: () => void
  ) {
    super();

    this.icon = icon;
    this.position.copyFrom(buttonStyle);
    if (!this.buttonStyle.defaultBgColor) buttonStyle.defaultBgColor = SwitcherBgColors.defaultBgColor;
    if (!this.buttonStyle.pressedBgColor) buttonStyle.pressedBgColor = SwitcherBgColors.pressedBgColor;

    this.onHandleFunc = onHandleFunc;
    this.onHandleSecondFunc = onHandleSecondFunc;
    this.updateBg = updateBg;

    this.createButton(this.icon);
    this.addInteractivity();
  }

  closeButton = () => this.handleDefaultButton(false);
  handleDefaultPosition = () => this.handleButton(false, this.buttonStyle.defaultBgColor, this.updateBg);
  setDisabled(v: boolean) {
    this.eventMode = v ? "none" : "static";
    this.filters = v ? [disabledfilter] : [];
  }
  private handlePressedButton() {
    this.handleButton(true, this.buttonStyle.pressedBgColor, this.updateBg);
    this.onHandleFunc();
  }
  private handleDefaultButton(withCB: boolean = true) {
    this.handleButton(false, this.buttonStyle.defaultBgColor, this.updateBg);
    withCB && this.onHandleSecondFunc()
  }
  private handleButton(isOn: boolean, fillColor: number, update: boolean) {
    this.isOn = isOn;
    this.ButtonRenderer.drawButtonBg(this.buttonBg, this.buttonStyle, fillColor, update, this.buttonStyle.border);
  }
  private createButton(icon: PIXI.Sprite | PIXI.Text | PIXI.Graphics) {
    const button = new PIXI.Container();
    this.handleButton(false, this.buttonStyle.defaultBgColor, true);
    icon instanceof PIXI.Text ? icon.anchor.set(.5) : "";
    button.addChild(this.buttonBg, icon);
    this.addChild(button);
  }
  private addInteractivity() {
    const handleDownFunc = () => this.isOn ? this.handleDefaultButton() : this.handlePressedButton();
    addInteractivity(this, { handleDownFunc }, CustomCursorType.pointer, undefined, true);
  }
  static generateText = (label: string, fontSize: number, fill: number = 0x333333) =>
    SwitcherButtonRenderer.generateText(label, fontSize, fill);
}